import { FcGeneratorOptions } from '@dtx-company/flowcode-generator-types/src'
import PromiseWorker from 'promise-worker'
import type {
  FCAutoScaleLogoWorkerInput,
  GeneratorWorkerOutput
} from './workers/autoscaleLogo.worker'

let promiseWorker: PromiseWorker | undefined

export async function fcAutoScaleLogo(
  options: FcGeneratorOptions,
  maxSize?: number,
  allowRotate?: boolean,
  allowMaxErrorCorrection?: boolean
): Promise<{ options: FcGeneratorOptions; hasLogoResized: boolean }> {
  // detect if Web workers are available
  if (self.Worker) {
    if (!promiseWorker) {
      const worker = new Worker(new URL('./workers/autoscaleLogo.worker', import.meta.url))
      promiseWorker = new PromiseWorker(worker)
    }
    const result = await promiseWorker.postMessage<
      GeneratorWorkerOutput,
      FCAutoScaleLogoWorkerInput
    >({
      options,
      maxSize,
      allowRotate,
      allowMaxErrorCorrection
    })
    if (result.ok) {
      return { options: result.opts, hasLogoResized: result.hasLogoResized }
    } else {
      throw new Error('Worker could not autoscale logo for flowcode')
    }
  } else {
    // fallback
    const module = await import('@dtx-company/flowcode-generator-v2/src')
    const result = await module.fcAutoScaleLogo(options)
    return { options: result.options, hasLogoResized: result.hasLogoResized }
  }
}
